import { objectId } from '@feathr/hooks';

import type { IDonationCreatedEvent } from './fundraisingEvents.types';

const FIRST_NAMES = [
  'Emma',
  'Liam',
  'Olivia',
  'Noah',
  'Ava',
  'Ethan',
  'Sophia',
  'Mason',
  'Isabella',
  'William',
  'Mia',
  'James',
  'Charlotte',
  'Benjamin',
  'Amelia',
  'Lucas',
  'Harper',
  'Henry',
  'Evelyn',
  'Alexander',
];

const LAST_NAMES = [
  'Smith',
  'Johnson',
  'Williams',
  'Brown',
  'Jones',
  'Garcia',
  'Miller',
  'Davis',
  'Rodriguez',
  'Martinez',
  'Hernandez',
  'Lopez',
  'Gonzalez',
  'Wilson',
  'Anderson',
  'Thomas',
  'Taylor',
  'Moore',
  'Jackson',
  'Martin',
];

const FORM_NAMES = [
  'Annual Giving Campaign',
  'Emergency Relief Fund',
  'Youth Programs',
  'General Donation',
  'Capital Campaign',
  'Scholarship Fund',
  'Community Outreach',
];

const COMMON_AMOUNTS = [10, 25, 50, 75, 100, 150, 200, 250, 500, 1000];

function randomElement<T>(array: readonly T[]): T {
  const randomValues = new Uint32Array(1);
  crypto.getRandomValues(randomValues);
  return array[randomValues[0] % array.length];
}

function randomAmount(): number {
  const randomValues = new Uint32Array(2);
  crypto.getRandomValues(randomValues);
  if (randomValues[0] % 10 > 3) {
    return randomElement(COMMON_AMOUNTS);
  }
  return (randomValues[1] % 500) + 5;
}

/**
 * Generate a mock donation event for testing and debugging.
 *
 * @param overrides - Optional overrides for specific fields
 * @returns A realistic mock donation event
 */
function generateMockDonation(
  overrides: Partial<IDonationCreatedEvent> = {},
): IDonationCreatedEvent {
  const amount = overrides.amount ?? randomAmount();
  const creditsEarned = Math.floor(amount * 0.1);
  const formId = objectId();

  return {
    id: objectId(),
    donor_first_name: randomElement(FIRST_NAMES),
    donor_last_name: randomElement(LAST_NAMES),
    amount,
    credits_earned: creditsEarned,
    donation_type:
      crypto.getRandomValues(new Uint32Array(1))[0] % 10 > 8 ? 'recurring' : 'one_time',
    form_id: formId,
    form_name: randomElement(FORM_NAMES),
    payment_method: crypto.getRandomValues(new Uint32Array(1))[0] % 10 > 7 ? 'ach' : 'credit_card',
    transaction_id: `txn_${objectId()}`,
    created_at: new Date().toISOString(),
    ...overrides,
  };
}

export { generateMockDonation };
